"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOpDefinitionPlaces = exports.opDefinitionPlacesQuery = void 0;
const PlaceModel_1 = __importDefault(require("@opsbase/lib-data-model/models/PlaceModel"));
const gql_1 = __importDefault(require("@opsbase/react-gql/gql"));
const GQLQueryArrayHook_1 = __importDefault(require("@opsbase/react-gql/GQLQueryArrayHook"));
const GQLResponseType_1 = __importDefault(require("@opsbase/react-gql/GQLResponseType"));
const OpDefinitionPlacesConfig = {
    model: PlaceModel_1.default,
    name: 'opDefinitionPlaces',
    response: GQLResponseType_1.default.ARRAY,
    params: {
        id: 'String',
        showMineOnly: 'Boolean',
        staffId: 'String',
    },
};
exports.opDefinitionPlacesQuery = (0, gql_1.default)(OpDefinitionPlacesConfig);
exports.useOpDefinitionPlaces = (0, GQLQueryArrayHook_1.default)(OpDefinitionPlacesConfig);
exports.default = exports.useOpDefinitionPlaces;
